import * as types from '../const/types';

export default (state = {}, action) => {
    switch (action.type) {
        case types.BOOKING_DETAIL_RETURN:
        case types.RETRIEVE_BOOKING_RETURN:
        case types.RETRIEVE_BOOKING_WITH_TOKEN_RETURN:
        case types.RETRIEVE_BOOKING_FOR_ADDON_RETURN:
        case types.PREREGISTER_RETURN:
            return { ...state,
                result: action.payload,
            }
        case types.ERROR:
            return { ...state,
                error: action.payload.result
            }
        default:
            return state
    }
}
